module.exports = __webpack_public_path__ + "static/media/sms.a76c63dc.svg";